export default __webpack_public_path__ + "static/media/1.74b37bc7.svg";